/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S5_Li4Inputs */

const tr_mesafeli_s5_li4 = /** @type {(inputs: Mesafeli_S5_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatura, QNB eSolutions altyapısı üzerinden e-Arşiv veya e-Fatura olarak düzenlenir ve Müşteri'ye kayıtlı e-posta adresine iletilir. Faturalar, Vergi Usul Kanunu Madde 253 kapsamındaki muhafaza yükümlülüğü saklı kalmak üzere, Türk Ticaret Kanunu Madde 82 uyarınca ilgili takvim yılının bitiminden itibaren 10 (on) yıl saklanır.`)
};

const en_mesafeli_s5_li4 = /** @type {(inputs: Mesafeli_S5_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The invoice is issued as an e-Arşiv or e-Fatura invoice via the QNB eSolutions infrastructure and delivered to the Customer's registered email address. Invoices are retained for 10 (ten) years from the end of the relevant calendar year under Article 82 of the Turkish Commercial Code (TTK), without prejudice to the retention obligation under Article 253 of the Tax Procedure Law (VUK).`)
};

const de_mesafeli_s5_li4 = /** @type {(inputs: Mesafeli_S5_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Rechnung wird über die Infrastruktur von QNB eSolutions als e-Arşiv- oder e-Fatura-Rechnung ausgestellt und dem Kunden an seine registrierte E-Mail-Adresse übermittelt. Rechnungen werden, unbeschadet der Aufbewahrungspflicht nach Artikel 253 des Steuerverfahrensgesetzes (VUK), nach Artikel 82 des türkischen Handelsgesetzbuchs (TTK) 10 (zehn) Jahre ab Ende des jeweiligen Kalenderjahres aufbewahrt.`)
};

const ru_mesafeli_s5_li4 = /** @type {(inputs: Mesafeli_S5_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Счёт выставляется через инфраструктуру QNB eSolutions в виде e-Arşiv или e-Fatura и направляется Клиенту на зарегистрированный адрес электронной почты. Счета хранятся 10 (десять) лет с окончания соответствующего календарного года согласно статье 82 Торгового кодекса Турции (TTK), без ущерба для обязанности хранения по статье 253 Закона о налоговом производстве (VUK).`)
};

/**
* | output |
* | --- |
* | "The invoice is issued as an e-Arşiv or e-Fatura invoice via the QNB eSolutions infrastructure and delivered to the Customer's registered email address. Invoi..." |
*
* @param {Mesafeli_S5_Li4Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s5_li4 = /** @type {((inputs?: Mesafeli_S5_Li4Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S5_Li4Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s5_li4(inputs)
	if (locale === "de") return de_mesafeli_s5_li4(inputs)
	if (locale === "ru") return ru_mesafeli_s5_li4(inputs)
	return tr_mesafeli_s5_li4(inputs)
});